import React from "react";
import Navbar from "../../Components/Navbar";
import { RolesSc } from "./index.sc";
import { useForm } from "react-hook-form";
import { createOrgRoles } from "../../api/users/createOrgRoles";
import { useAuthContext } from "../../hooks";
import { Button } from "react-bootstrap";
function Index() {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const auth = useAuthContext();
  const handleCreateRoles = async (e: any) => {
    console.debug("data > ", e);
    await createOrgRoles(auth?.userInfo?.orgs[0]?.id, {
      ...e,
      created_by: (auth?.userInfo?.id).toString(),
    })
      .then((e) => {
        console.log(e);
      })
      .catch((err) => {
        console.log("====================================");
        console.log(err);
        console.log("====================================");
      });
  };
  const onSubmit = async (e: any) => {
    console.log("I am Here", e);
    await handleCreateRoles(e);
    reset();
  };
  return (
    <RolesSc>
      <div className="roles-container">
        <form onSubmit={handleSubmit(onSubmit)}>
          <label>Organization Role</label>
          <input
            {...register("name", {
              required: { value: true, message: "This is required" },
            })}
          />
          <label>Role Description</label>
          <input
            {...register("description", {
              required: { value: true, message: "This is required" },
            })}
          />
          <Button type="submit">Create Role</Button>
        </form>
      </div>
    </RolesSc>
  );
}

export default Index;
